import { render, staticRenderFns } from "./LampDetails.vue?vue&type=template&id=65de2050&"
import script from "./LampDetails.vue?vue&type=script&lang=js&"
export * from "./LampDetails.vue?vue&type=script&lang=js&"
import style0 from "./LampDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports